module.exports = __webpack_public_path__ + "img/nr.b5747a11.png";